var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.channels && _vm.channels.length)?_c('Layout',{attrs:{"hidden-overflow":""}},[_c('h1',{class:_vm.$style.mainHeading},[_vm._v("Radio")]),_c('ChannelDetailBlock',{attrs:{"channels":_vm.channels,"playlists":_vm.playlists,"is-favorites":_vm.isFavorites}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }